export default __webpack_public_path__ + "static/media/graph.9d356f9f.png";